import React, { useEffect, useState, useMemo } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./Routes";
import AppRoute from "./Routes/route";
import Header from "./Components/Pages/Home/NavbarIndex";
import Footer from "./Components/Pages/Home/FooterIndex";
import { Suspense } from "react";
import Skeleton from "./Components/Pages/Home/Skeleton";
import Loader from "./Components/Ui/Loader";

function App() {
  const [currentPath, setCurrentPath] = useState("");

  const getProtectedRoutes = useMemo(() => {
    return authProtectedRoutes.map((route) => (
      <AppRoute
        path={route.path}
        component={route.component}
        isAuthProtected={true}
        pageId={route.pageId}
        exact={route.exact}
      />
    ));
  }, [authProtectedRoutes]);

  const getPublicRoutes = useMemo(() => {
    return publicRoutes.map((route) => (
      <Route
        path={route.path}
        component={route.component}
        isAuthProtected={false}
        pageId={route.pageId}
        exact={route.exact}
        render={(props) => (
          <>
            <route.component {...props} />
          </>
        )}
      />
    ));
  }, [publicRoutes]);

  React.useEffect(() => {
    setCurrentPath(window.location.pathname);
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPath]);

  return (
    <React.Fragment>
      {/* <Route component={Header} /> */}
      <Suspense
        fallback={
          <Loader
            customStyle={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        }
      >
        <Switch>{[ ...getPublicRoutes, ...getProtectedRoutes]}</Switch>
      </Suspense>
      {/* <Route component={Footer} /> */}
    </React.Fragment>
  );
}

export default App;
